// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Xi+O0","lupa":"Header_lupa__Vx82m","lupaDisplay":"Header_lupaDisplay__LS3A2"};